import { ApiConnector, GET } from "./request.service";

export default (() => {
  const API = ApiConnector("/cities");
  let domain = window.location.hostname.split(".")[
    window.location.hostname.split(".").length - 1
  ];
  // domain = "by";
  return {
    GetAllCities: async (query = { token: "!Aa12345", size: 9999 }) =>
      await API(GET, `/${domain}`, false, query).call(),
    GetDefaultCity: async () => await API(GET, `/${domain}/default`).call(),
    GetCityOffices: async () => await API(GET, `/${domain}/default`).call(),
  };
})();
